import { axiosPost } from '@/api/AxiosApi';

export type ResTickerProps = {
  id: number;
  base: string;
  base_dt: string;
  latest_price: string;
  best_bid: string;
  best_ask: string;
  high24h: string | null;
  low24h: string | null;
  volume24h: string | null;
  reg_dttm: string;
};
type tickerProps = {
  symbol: string;
  amount: string;
};
export const ticker = async ({
  symbol,
  amount = '1',
}: tickerProps): Promise<{ ret_code: number; msg: string; data: ResTickerProps; statusCode?: number }> => {
  const payload = {
    path: '/tickers',
    body: {
      symbol,
      amount,
    },
  };

  const { data: re } = await axiosPost(payload);
  return re;
};
